import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next"
import { Button, ButtonList, PageHeader, PenModal, SECTION_ATTENTION, SECTION_BASIC, SECTION_REMAININGTODAY, SECTION_REMAININGYESTERDAY, SectionModal, ToggleBox, NewModal, MainContentPaddingTypes, Overlay } from "../../../../Components"
import { colors, css, fonts, frames, glyphs, images, useMediaQuery } from '../../../../Styles';
import { SectionBasicTypes } from '../../../../Components/LocationFeeder/Section/sectionBasic';
import { ButtonTypes } from '../../../../Definitions';
import NewSectionModal from '../../../../Components/LocationFeeder/Modals/newSectionModal';
import { useSection } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections';
import { useAppSelector } from '../../../../Store';
import { Graph_QL } from '../../../../Services';
import { useAnimal } from '../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal';
import { useLocation, useParams } from 'react-router';
import { useSystem } from '../../../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem';
import { Pages } from '../../../../Navigation/Routers/root';
import { LfLocation } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall';

const SYSTEM_ID = 1

export default function FreedaLocationFeeder() {
  const {t} = useTranslation()
  const [isHoveredSection, setHoveredSection] = useState<number | null>(null);
  const [activeSectionId, setActiveSectionId] = useState<number | null>(null);
  const [activePen, setActivePen] = useState<LfLocation | undefined>();
  const [isRemainingToday, setRemainingToday] = useState<boolean>(true) // Section Remaining Today
  const [isRemainingYesterday, setRemainingYesterday] = useState<boolean>(false) // Section Remaining Yesterday
  const [attention, setAttention] = useState<boolean>(false) // Section Attentions
  const [editTable, setEditTable] = useState(false)
  const [newSectionModal, setNewSectionModal] = useState(false)
  const [camModal, setCamModal] = useState<boolean>(false)
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  const {systemId: urlSystemId} = useParams(); // TODO routing changes in order to get a correct system info
  const location = useLocation();
  // const systemId = useMemo(
  //   () => (urlSystemId ? +urlSystemId : location.state?.selected),
  //   [urlSystemId, location]
  // );
  const systemId = urlSystemId ? +urlSystemId : SYSTEM_ID;

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({ domain: farm })), [farm]);

  const { call: getLfSectionsInfo, data: lfSectionsState } = useSection(connection);
  const { call: getAnimalsInfo } = useAnimal(connection);
  const { call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({ids: [systemId]})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  // console.log("system ",systemId)

  // Get System Name for Header
  const systemName = systemsState[domain]?.data.find((system) => system.systemId === systemId)?.name

  const sections = useMemo(() => (lfSectionsState[domain] ? lfSectionsState[domain].data.filter(s => s.system_id === systemId): undefined),[domain, lfSectionsState, systemId])
  useEffect(() => {
    getLfSectionsInfo({ids: [systemId]}, connection);
  // eslint-disable-next-line
  }, [])
  
  // Extract section IDs from Sections data
  const sectionIds = useMemo(() => (sections?.map((section) => section.section_id) ?? [0]),[sections]);
  const firstSectionId = sectionIds[0];
  const lastSectionId = sectionIds[sectionIds.length - 1];
  
  // Extract location IDs from Sections data
  const locationsIds = useMemo(() => {
    const accumulator:number[] = []
    return (sections?.reduce((accumulator, currentSection) => (accumulator.concat(currentSection.section_locations.map((location) => location.location_id))),accumulator ))
  },[sections])

  useEffect(() => {
    getAnimalsInfo({ids:locationsIds, idIdentifier: "fk_locations"}, connection)
  }, [connection, getAnimalsInfo, locationsIds])

  useEffect(() => {
    setActivePen((old) => {
      if (old) {
        const location = sections?.flatMap((section) => (section.section_locations)).find((location) => (location.location_id === old.location_id));
        
        if (location) {
          return {...location};
        }
        return undefined;
      }
      return old
    })
  },[sections])

  // Find indexes for prev/next functions and names
  if (!sections) return null
  const currentSectionIndex = sections.findIndex(s => s.section_id === activeSectionId);
  const currentSectionName = sections?.[currentSectionIndex]?.name
  const currentSectionPens = sections?.[currentSectionIndex]?.section_locations ?? [];
  const currentPenIndex = currentSectionPens.findIndex(pen => pen.location_id === activePen?.location_id);
  const currenPenName = currentSectionPens?.[currentPenIndex]?.name

  // #region | Sections Functionality (toggles, section-click)
  // Toggle Btn Remaining Today
  const toggleRemainingToday = () => {
    if (isRemainingToday) {
      setRemainingToday(false); // If already active, set it to false
    } else {
      setRemainingToday(true);
      setRemainingYesterday(false);
      setAttention(false);
    }
  };
  
  // Toggle Btn Remaining Yesterday
  const toggleRemainingYesterday = () => {
    if (isRemainingYesterday) {
      setRemainingYesterday(false); // If already active, set it to false
    } else {
      setRemainingYesterday(true);
      setRemainingToday(false);
      setAttention(false);
    }
  };

  // Toggle Btn Attentions
  const toggleAttentions = () => {
    if (attention) {
      setAttention(false); // If already active, set it to false
    } else {
      setAttention(true);
      setRemainingYesterday(false);
      setRemainingToday(false);
      
    }
  };

  // Switch between edit mode and non-edit mode
  const switchTable = () => {
    setEditTable((editTable) => !editTable);
    setAttention(false)
    setRemainingToday(false)
    setRemainingYesterday(false)
  };
  // #endregion

  // Function to handle pen selection from SectionModal
  function handlePenSelected(penId: number) {
    setActivePen(currentSectionPens.find((pen) => pen.location_id === penId));  // Set the active pen to open the PenModal
  }

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={systemName} subHeader={t(`menuHeaders.${Pages.freeda_lf_sections}`, {defaultValue: "sections"})}/>
      </frames._page_inner_header>
      <frames._page_inner_content style={{zIndex: editTable ? "9999" : "0"}}>
        <frames._grid_topBtns_outer>
          <frames._grid_topBtns_inner>
            {(sections.length === 0 || sections === undefined) ? <div></div> : <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>{t("locationFeederPages.sections.section", {defaultValue: "section"})} {firstSectionId} {t("to", {defaultValue: "to"})} {lastSectionId}</p>}
          
            {!editTable? 
              <ButtonList 
                contents={[t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"})]} 
                onClick={(i => {
                  if (i === 0) {setNewSectionModal(true)}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Add({}), glyphs.Edit({})]}
              />
            : <ButtonList 
                contents={[t("buttons.save", {defaultValue: "save"}), t("buttons.cancel", {defaultValue: "cancel"}),t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"})]} 
                onClick={(i => {
                  if (i === 0) {}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({})]}
                disabled={[false, false, true, true]}
                overrides={(index) => ({
                  baseButton: {
                    backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary
                  },
                  disabledStyles: {
                    opacity: index === 3 ? 1 : 0.5
                  }
                })}
              />
            }
          </frames._grid_topBtns_inner>
          <frames.Grid_oneRow>
            <frames._grid_oneRow_top>
              <frames._grid_top_toggleBox_container style={{columnGap: mobileXs ? "10px" : "30px"}}>
                <ToggleBox disabled={editTable? true : false} text={t("feed.general.remainingToday", {defaultValue: "remaining today"})} icon={glyphs.TimeToday({size: "17px"})} onChange={() => toggleRemainingToday()} isChecked={isRemainingToday? true : false}/> 
                <ToggleBox disabled={editTable? true : false} text={t("feed.general.remainingYesterday", {defaultValue: "remaining yesterday"})} icon={glyphs.TimeYesterday({size: "17px"})} onChange={() => toggleRemainingYesterday()} isChecked={isRemainingYesterday? true : false}/>
                <ToggleBox disabled={editTable? true : false} text={t("systemControls.general.attentions", {defaultValue: "attentions"})} icon={<div style={{marginTop: "1px"}}><glyphs.Attention size="17px"/></div>} onChange={() => toggleAttentions()} isChecked={attention? true : false}/>
              </frames._grid_top_toggleBox_container>
            </frames._grid_oneRow_top>
            <frames._grid_oneRow_content style={{justifyContent: mobileXs ? "center" : "start"}}>
              <frames._grid_camButton_container>
                <Button content=''
                  startEnhancer={glyphs.Cam({size: "40px"})}
                  overrides={{
                    baseButton: {width: "50px", backgroundColor: colors.greySecondary},
                    startEnhancerStyles: {margin: "0px"},
                    hoverStyles: {backgroundColor: colors.greyPrimary}
                  }}
                  onClick={() => setCamModal(true)}
                  disabled={editTable ? true : false}
                />
              </frames._grid_camButton_container>
              {sections?.map(({section_id: sectionId, section_locations: pens, name}) => (
                <frames._grid_section_frame key={sectionId} 
                  onClick={() => setActiveSectionId(sectionId)}
                  onMouseEnter={() => setHoveredSection(sectionId)}
                  onMouseLeave={() => setHoveredSection(null)}
                  style={{ filter: isHoveredSection === sectionId ? 'opacity(0.5)' : 'opacity(1)'}} >
                    <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, textAlign: "center", marginBottom: "10px"}}>{name}</p>
                    { isRemainingToday?
                      <SECTION_REMAININGTODAY
                        sectionId={sectionId}
                        pens={pens}
                      />
                    : isRemainingYesterday?
                      <SECTION_REMAININGYESTERDAY 
                        sectionId={sectionId}
                        pens={pens}
                      />
                    : attention?
                      <SECTION_ATTENTION
                        sectionId={sectionId}
                        pens={pens}
                      />
                    : <SECTION_BASIC 
                        sectionId={sectionId} 
                        sectionType={SectionBasicTypes.basicPen}
                        pens={pens}
                      />
                    }
                    <div style={{position: "absolute", top: 0, right: 0}}><glyphs.Corner fillColor={colors.greyTertiary} rotate={90}/></div>
                    <div style={{position: "absolute", bottom: 0, right: 0}}><glyphs.Corner fillColor={colors.greyTertiary} rotate={180}/></div>
                    <div style={{position: "absolute", bottom: 0, left: 0}}><glyphs.Corner fillColor={colors.greyTertiary} rotate={270}/></div>
                    <div style={{position: "absolute", top: 0, left: 0}}><glyphs.Corner fillColor={colors.greyTertiary}/></div>
                  </frames._grid_section_frame>
                ))}
                {(sections.length === 0 || sections === undefined) && <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>No sections</p>}
            </frames._grid_oneRow_content>
          </frames.Grid_oneRow>
        </frames._grid_topBtns_outer>
      </frames._page_inner_content>

      {/* Section and pen Modals */}
      <NewModal
        modalState={ activeSectionId !== null || activePen !== undefined}
        header={ activePen !== undefined ? `${t("locationFeederPages.locationFeeder.pen", {defaultValue: "Pen"})} ${currenPenName}` : currentSectionName }
        subHeader={ activePen !== undefined ? `${systemName} ${currentSectionName}` : `${systemName}` }
        overrides={{
          backgroundColor: colors.greyLightTertiary,
          mainContentPadding: MainContentPaddingTypes.primary,
          mainContentScroll: true
        }}
        predefinedButtons={{
          onClose: () => {
            setActiveSectionId(null)
            if (activePen !== undefined) setActivePen(undefined)
          },
          onGoBack: activePen !== undefined ? () => setActivePen(undefined) : undefined,
          onPrev:  () => activePen !== undefined 
          ? setActivePen(currentSectionPens[(currentPenIndex - 1 + currentSectionPens?.length) % currentSectionPens.length]) 
          : setActiveSectionId(sectionIds[(currentSectionIndex - 1 + sectionIds.length) % sectionIds.length]),
          onNext: () => activePen !== undefined 
          ? setActivePen(currentSectionPens[(currentPenIndex +1 ) % currentSectionPens.length])
          : setActiveSectionId(sectionIds[(currentSectionIndex + 1) % sectionIds.length])
        }}
        mainContent={
          <div style={{width: "650px"}}>
            { activePen === undefined && activeSectionId !== null? 
              <SectionModal activeSectionId={activeSectionId} onPenSelected={handlePenSelected} pens={currentSectionPens}/> // SECTION POPUP
            : activePen !== null? 
              <PenModal activePen={activePen}/> // PEN POPUP
            : null 
            }
          </div>
        }
      />

      {editTable && <Overlay/>}
      {camModal && (
        <NewModal
          modalState={true}
          predefinedButtons={{ onClose: () => setCamModal(false) }}
          header={`${systemName} ${t("locationFeederPages.sections.map",{defaultValue: "map"})}`}
          mainContent={ <img src={images.systemView} alt={`${systemName} ${t("locationFeederPages.sections.map",{defaultValue: "map"})}`} style={{ width: "100%", borderRadius: "0px 0px 10px 10px" }} /> }
        />
      )}
      <NewSectionModal 
        isModalOpen={newSectionModal}
        closeModal={() => {setNewSectionModal(false);}}
        systemId={systemId}
      />
    </frames.Page_inner>
  )
} 